import Accordion from '@/common/components/Accordion'
import InfoField from '@/common/components/InfoField'
import { EquipmentModelLatestFipeDataPerformance } from '@/features/equipmentModels/types/equipmentModelLatestFipe'

interface FipePerformanceAccordionProps {
  performanceData?: EquipmentModelLatestFipeDataPerformance
}

export default function FipePerformanceAccordion({ performanceData }: FipePerformanceAccordionProps) {
  return (
    <Accordion
      name="Performance"
      head="Desempenho"
      body={
        <div className='flex items-center gap-1'>
          <InfoField 
            label="Velocidade máxima" 
            value={performanceData?.["Velocidade Maxima"]} 
          />
          <InfoField 
            label="Aceleração" 
            value={performanceData?.Aceleracao} 
          />
        </div>
      }
    />
  )
}